import React from 'react'
import {
  Segment,
  Item
} from 'semantic-ui-react'
import {getPP, getVehicle} from "../misc/Helpers";

function ReportList({ isReportsLoading, reports }) {
  let reportList
  if (reports.length === 0) {
    reportList = <Item key='no-reports'>Отчетов не найдено</Item>
  } else {
    reportList = reports.map(report => {
          return (
              <Item key={report.id}>
                  <Item.Content>
                      <Item.Header>{getPP(report.pp)}
                      </Item.Header>
                      <Item.Meta>{new Date(report.tripDate).toLocaleString('ru',
                          { year: 'numeric', month: 'short', day: 'numeric' })}</Item.Meta>
                      <Item.Description>
                        Отчёт составил {report.author.name} <br/>
                        Приехали на границу {report.startHour}:{report.startMin} <br/>
                        Транспорт {getVehicle(report.vehicleType)} <br/>
                        Прошли первую границу {report.firstBorderHour}:{report.firstBorderMin} <br/>
                        Прошли вторую границу {report.secondBorderHour}:{report.secondBorderMin} <br/>
                        Итого в пути {report.total} часов <br/>
                      </Item.Description>
                      <Item.Extra>
                          Примечание <br/>
                          {report.notes}
                      </Item.Extra>
                  </Item.Content>
              </Item>
          )
      })
  }

  return (
    <Segment loading={isReportsLoading} color='blue'>
      <Item.Group divided unstackable relaxed>
        {reportList}
      </Item.Group>
    </Segment>
  )
}

export default ReportList
